// const EXISTING_CUSTOM_JOINS = ["IARCombo", "IReadyCombo", "StarCombo"];

export const getActiveCustomJoins = ({
  accountCustomJoins,
  dataCollection,
  currentAnchorSlug,
}) => {
  const customJoinsSlugs = [];
  const currentAccountCustomJoinNames =
    accountCustomJoins?.map((join) => join?.securityContext?.complexJoinName) || [];


  if (dataCollection && dataCollection[currentAnchorSlug]) {
    Object.keys(dataCollection[currentAnchorSlug]).forEach((dataTableSlug) => {
      if (
        // EXISTING_CUSTOM_JOINS.includes(dataTableSlug) ||
        currentAccountCustomJoinNames.includes(dataTableSlug)
      ) {
        customJoinsSlugs.push(dataTableSlug);
      }
    });
  }

  return customJoinsSlugs;
};
